import '@fancyapps/fancybox';
import getActionByRoute from './../utils/getActionByRoute';
import ArticlesResize from './articlesResize';
import { articleFixBar, articleFixSocialShare } from './articleFixBar';

const ArticleModule = {
  run: (action) => {
    ArticleModule[action].call();
  },
  index: () => ArticlesResize(),
  show() {
    articleFixBar();
    articleFixSocialShare();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  ArticleModule.run(getActionByRoute().action);
});



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/articles/articles.js